import { render } from "./VariableAccordion.vue?vue&type=template&id=679d01a8&scoped=true&ts=true"
import script from "./VariableAccordion.vue?vue&type=script&lang=ts"
export * from "./VariableAccordion.vue?vue&type=script&lang=ts"

import "./VariableAccordion.vue?vue&type=style&index=0&id=679d01a8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-679d01a8"]])

export default __exports__